import { useCallback, useEffect, useState } from 'react';

import { trucksAPI } from '../../lib/api';

/**
 * Le camion lui-même, base de la fiche.
 *
 * `trucksAPI.getById` retombe sur le cache local hors ligne: la fiche doit
 * s'ouvrir dans la cabine sans réseau, même si les agrégats du profil, eux,
 * restent indisponibles.
 */
export function useTruck(truckId) {
  const [truck, setTruck] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    if (!truckId) return null;
    setLoading(true);
    setError(false);
    try {
      const row = await trucksAPI.getById(truckId);
      setTruck(row || null);
      return row || null;
    } catch {
      setError(true);
      return null;
    } finally {
      setLoading(false);
    }
  }, [truckId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { truck, setTruck, loading, error, reload };
}

/**
 * Le bandeau de la fiche: statut affiché, immobilisation, papiers à échéance,
 * alertes ouvertes, trajet en cours. Uniquement en ligne; un échec laisse la
 * fiche utilisable (`profile` reste `null`, `unavailable` passe à vrai).
 */
export function useTruckProfile(truckId) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unavailable, setUnavailable] = useState(false);

  const reload = useCallback(async () => {
    if (!truckId) return;
    setLoading(true);
    try {
      const data = await trucksAPI.getProfile(truckId);
      setProfile(data || null);
      setUnavailable(!data);
    } catch {
      setProfile(null);
      setUnavailable(true);
    } finally {
      setLoading(false);
    }
  }, [truckId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { profile, loading, unavailable, reload };
}

export default useTruck;
